import { Text } from '@thefarmersfront/kitchen';

import type { CustomCellRendererProps } from 'ag-grid-react';

import { formatNumber } from '~/utils';

import type { TypeReceiveStatusDetailItem } from '~/types/receive.types';

import styles from './ReceiveStatusQtyDetailCell.module.scss';

/**
 * [입고관리 > 입고현황] 입고 현황 상세 모달 내 셀 렌더러
 */
const ReceiveStatusQtyDetailCell = ({
  data,
}: CustomCellRendererProps<TypeReceiveStatusDetailItem['details'][number]>) => {
  const isPassed = data?.isPassed ?? false;

  return (
    <Text className={styles['multi-row-value']} size="large" color={isPassed ? 'success' : 'error'}>
      {data?.qty && data.qty > 0 ? formatNumber(data.qty) : '-'}
    </Text>
  );
};

export default ReceiveStatusQtyDetailCell;
